import { useEffect } from "react";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


import './index.css';




const AlertaLoad = () => {



  useEffect(() => {
    
  }, []);

  return (

    <>


      <Breadcrumb>
         <Breadcrumb.Item href="#">Alerta Load</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col className="text-center fs-4">
           <h1>SRO Conferência Web - Versão 0.0.47.001</h1>
         </Col>
      </Row>

    </>

  );
}

export default AlertaLoad